"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.muiTheme = exports.default = exports.Theme = exports.ScrollableStyles = exports.ScreenSize = void 0;
var _core = require("@material-ui/core");
var Theme = {
  color: {
    primary: '#071d33',
    secondary: '#1e498c',
    link: '#071d33',
    white: '#fff',
    black: '#000',
    success: '#51b249',
    danger: '#F15B47',
    info: '#1e498c',
    warning: '#F3bb44',
    muted: '#c3c3c3',
    light: '#f8f8f8'
  },
  font: {
    // Font
    baseColor: 'rgba(0, 0, 0, 0.87)',
    mutedColor: 'rgba(0, 0, 0, 0.54)',
    smallSize: '12px',
    baseSize: '14px',
    mediumSize: '16px',
    largeSize: '18px',
    megaSize: '24px',
    boldWeight: '700',
    baseWeight: '400',
    thinWeight: '300',
    baseFamily: 'Lato, sans-serif, serif',
    codeFamily: 'Source Code Pro, monospace'
  }
};
exports.Theme = Theme;
var muiTheme = (0, _core.unstable_createMuiStrictModeTheme)({
  flatButton: {
    textTransform: 'none',
    fontSize: Theme.font.baseSize,
    buttonFilterColor: Theme.color.secondary
  },
  TableRowColumn: {
    whiteSpace: 'normal',
    wordWrap: 'break-word'
  },
  palette: {
    primary: {
      main: Theme.color.primary,
      contrastText: Theme.color.white
    },
    secondary: {
      main: Theme.color.secondary,
      contrastText: Theme.color.white
    },
    contrastThreshold: 3,
    tonalOffset: 0.2
  },
  typography: {
    fontFamily: Theme.font.baseFamily,
    body1: {
      fontSize: Theme.font.baseSize
    },
    button: {
      lineHeight: '150%'
    }
  }
});
exports.muiTheme = muiTheme;
var ScreenSize = {
  mobile: '400px',
  tablet: '600px'
};
exports.ScreenSize = ScreenSize;
var ScrollableStyles = "\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: ".concat(Theme.color.white, ";\n  }\n\n  &::-webkit-scrollbar-track {\n    border-radius: 40px;\n    background: rgba(0, 0, 0, 0.1);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    background: ").concat(Theme.color.secondary, ";\n  }");
exports.ScrollableStyles = ScrollableStyles;
var _default = Theme;
exports.default = _default;